import axios from "axios";
import store from "../state/store";

const axiosDefault = axios.create({
    timeout: 100000,
    headers: {
        'Content-Type': 'application/json'
    }
});

axiosDefault.interceptors.request.use(async reqConfig => {
    try {
        reqConfig.baseURL = window.Use?.config?.baseURL ?? "/";
        const state = store.getState();
        const authToken = state.user.bearerToken;
        reqConfig.headers['Authorization'] = `Bearer ${authToken}`;
    } catch (err) {
        return Promise.reject(err);
    }
    return reqConfig;
}, err => Promise.reject(err));

export default axiosDefault;